import React, { useMemo } from 'react';
import { AvatarWrapper, ContactLink, TooltipContent, UserInfo, UserJob, Wrapper } from './user-profile.styles';
import { UserProfileProps } from './types';
import { Tooltip as JuicyTooltip } from '@vtbhome/juicyfront';
import { Typography } from '../typography/typography';
import { AVATAR_WRAPPER_SIZE_MAP, TYPOGRAPHY_SIZE_MAP, PHOTO_SIZE_MAP } from './user-profile.mixins';
import { Inbox } from '@vtbhome/juicyfront/indexIcon';
import { ITooltipProps } from '@vtbhome/juicyfront/components/atoms/Tooltip/Tooltip';
import { Photo } from '../photo/photo';
import { PhotoSize } from '../photo/types';

export const UserProfile: React.FC<UserProfileProps> = ({ size = 'm', text, avatarUrl, tooltipData }) => {
    const { Tooltip, tooltipProps } = useMemo(() => {
        return {
            Tooltip: tooltipData ? JuicyTooltip : React.Fragment,
            tooltipProps: tooltipData ? ({ position: 'top' } as ITooltipProps) : {},
        };
    }, [tooltipData]);

    return (
        <Tooltip {...tooltipProps}>
            <Wrapper size={size}>
                <AvatarWrapper size={AVATAR_WRAPPER_SIZE_MAP[size]}>
                    <Photo size={PHOTO_SIZE_MAP[size] as PhotoSize} photoUrl={avatarUrl} name={text} />
                </AvatarWrapper>
                <Typography size={TYPOGRAPHY_SIZE_MAP[size]}>{text}</Typography>
            </Wrapper>
            {tooltipData && (
                <TooltipContent>
                    <Photo size='xxxl' photoUrl={avatarUrl} name={text} />
                    <UserInfo>
                        <Typography size='h6'>{tooltipData.name}</Typography>
                        <UserJob>
                            <Typography size='body1_short' color='neutral_50'>
                                {tooltipData.jobPost}
                            </Typography>
                            <Typography size='body1_short' color='neutral_50'>
                                {tooltipData.department}
                            </Typography>
                        </UserJob>
                        {tooltipData.email && (
                            <ContactLink href={`mailto:${tooltipData.email}`}>
                                <Inbox />
                                {tooltipData.email}
                            </ContactLink>
                        )}
                    </UserInfo>
                </TooltipContent>
            )}
        </Tooltip>
    );
};
